import useVahakHttpClient from '../../hooks/useVahakHttpClient.js';
import { useVahakMutationQuery } from '../../hooks/useVahakQueryClient.js';
import API from '../const.js';
import { QueryNames } from './queryNames.js';

const useSendWhatsappMessage = () => {
    const { POST } = useVahakHttpClient();
    function sendWhatsAppMessage(data) {
        /**
         * The first generic is for the body type you are sending
         * Second generic is the data returned
         */
        return POST(API.SEND_WHATSAPP_MESSAGE, Object.assign({}, data));
    }
    /**
     * The second generic either send unknown or the error type
     */
    return useVahakMutationQuery(QueryNames.sendWhatsAppMessage, sendWhatsAppMessage);
};

export { useSendWhatsappMessage };
//# sourceMappingURL=useSendWhatsappMessageService.js.map
